export default "__VITE_ASSET__C44m$XtK__"